export default function DataSourceSkeleton() {
  return (
    <div className="p-4 border border-gray-200 rounded-lg bg-gray-50 animate-pulse space-y-3">
      <div className="h-4 bg-gray-300 rounded w-3/4" />
      <div className="h-3 bg-gray-300 rounded w-1/2" />
      <div className="h-3 bg-gray-300 rounded w-2/3" />
      <div className="h-3 bg-gray-300 rounded w-1/3" />
    </div>
  );
}
